/* eslint-disable no-script-url */
import _ from "lodash"
import { connect } from "react-redux"
import React, { PureComponent } from "react"
import OrderCreateAccountSelect from "@/components/orderCreateAccountSelect"
import PromotedObjectSelect from "@/business-components/sale/PromotedObjectSelect"
import { Input, FormGroup, FileUploader, Icon, Collapse } from "@tencent/spaui"

const requiredFieldMap = {
  operation_mode: { tip: "请选择运营方式", errField: "operationModeErr" },
  // ad_platform_types: { tip: "请选择推广目标", errField: "adPlatformTypeErr" },
  // promoted_object: { tip: "请选择二级投放目标", errField: "promotedObjectErr" },
  // promotion_business: { tip: "请输入推广业务/产品/内容", errField: "promotionBusinessErr" },
  // day_budget_promised: { tip: "请输入客户上线承诺备注-每日预算", errField: "dayBudgetPromisedErr" },
  // online_time_promised: { tip: "请输入客户上线承诺备注-上线时间", errField: "onlineTimePromisedErr" },
}

const requiredFieldMapByGDT = {
  operation_mode: { tip: "请选择运营方式", errField: "operationModeErr" },
}

const requiredFieldMapByWeChat = {
  operation_mode: { tip: "请选择运营方式", errField: "operationModeErr" },
}

const ATTACHMENT_UPLOAD_URL = "/ags/attachment/upload"

class advertisingInfo extends PureComponent {
  state = {
    // error提示
    operationModeErr: "",
    adPlatformTypeErr: "",
    promotedObjectErr: "",
    promotionBusinessErr: "",
    dayBudgetPromisedErr: "",
    onlineTimePromisedErr: "",
    effectPromisedErr: "",
    memoPromisedErr: "",
    competitionErr: "",
    landingPageUrlErr: "",
    creativeAttachmentIdsErr: "",
    uploadStatus: {}, // 附件上传状态
    attachmentText: [], // 附件名称
    open: true, //collapse展开状态
  }

  componentDidMount() {
    this.props.onRef(this)
  }

  componentWillUnmount() {
    this.fileUploaderRef = null
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ agency_uid: nextProps.agencyUid })
  }

  changeOperationMode = (event, value) => {
    this.props.onChange("advertisingInfo", { ...this.props.value, operation_mode: value })
    this.inputValidate(value, "operation_mode")
  }

  changeLandingPageUrl = (event, value) => {
    this.props.onChange("advertisingInfo", { ...this.props.value, landing_page_url: value })
  }

  changeCompetition = (event, value) => {
    this.props.onChange("advertisingInfo", { ...this.props.value, competition: value })
  }

  changeMemoPromised = (event, value) => {
    this.props.onChange("advertisingInfo", { ...this.props.value, memo_promised: value })
  }

  changeEffectPromised = (event, value) => {
    this.props.onChange("advertisingInfo", { ...this.props.value, effect_promised: value })
  }

  changeOnlineTimePromised = (event, value) => {
    this.props.onChange("advertisingInfo", { ...this.props.value, online_time_promised: value.trim() })
    // this.inputValidate(value.trim(), "online_time_promised")
  }

  changeDayBudgetPromised = (event, value) => {
    this.props.onChange("advertisingInfo", { ...this.props.value, day_budget_promised: value.trim() })
    // this.inputValidate(value.trim(), "day_budget_promised")
  }

  changePromotionBusiness = (event, value) => {
    this.props.onChange("advertisingInfo", { ...this.props.value, promotion_business: value.trim() })
    // this.inputValidate(value.trim(), "promotion_business")
  }

  changePromotedObject = (value) => {
    const { adPlatformTypes, promotedObject } = value;
    this.props.onChange('advertisingInfo', { ...this.props.value, ad_platform_types: adPlatformTypes, promoted_object: promotedObject });
  }

  deleteAttachment = (item, key) => {
    let creative_attachment_ids = this.props.value.creative_attachment_ids
    if (creative_attachment_ids && creative_attachment_ids.values) {
      creative_attachment_ids.values.splice(key, 1)
    } else {
      creative_attachment_ids.values = []
    }

    let creativeAttachments = this.props.value.creativeAttachments
    creativeAttachments.splice(key, 1)
    this.props.onChange("advertisingInfo", { ...this.props.value, creative_attachment_ids: creative_attachment_ids })
    this.props.onChange("advertisingInfo", { ...this.props.value, creativeAttachments: creativeAttachments })
  }

  handleCreativeAttachmentIds = (response, fileTarget) => {
    const {
      attachmentId, // 附件Id，保存投放详情时提交
      attachmentName, // 附件名称
      url, // 附件链接
    } = response
    const attachmentText = this.state.attachmentText
    attachmentText.push(attachmentName)
    this.setState({
      attachmentText: attachmentText,
    })

    let text
    if (attachmentText.length <= 2) {
      text = `${attachmentText.join("、")}等${attachmentText.length}个文件`
    } else {
      text = `${attachmentText[0]} + ${attachmentText[1]}...等${attachmentText.length}个文件`
    }

    // 上传状态
    const data = {
      url: url,
      name: text,
      status: "success",
    }
    if (attachmentId) {
      this.setState({
        // uploadStatus: data
        uploadStatus: {},
      })
      const new_creative_attachment_ids = _.cloneDeep(
        this.props.value.creative_attachment_ids
          ? this.props.value.creative_attachment_ids
          : {
            values: [],
          }
      )
      new_creative_attachment_ids.values.push(attachmentId)
      this.props.onChange("advertisingInfo", { ...this.props.value, creative_attachment_ids: new_creative_attachment_ids })

      // this.props.creativeAttachments 附件详细信息
      const new_creative_attachments = _.cloneDeep(this.props.value.creativeAttachments ? this.props.value.creativeAttachments : [])
      new_creative_attachments.push({
        attachmentName: attachmentName,
        url: url,
      })
      this.props.onChange("advertisingInfo", { ...this.props.value, creativeAttachments: new_creative_attachments })
    } else {
      setTimeout(() => {
        this.setState({
          uploadStatus: {
            url: "http://www.placehold.it/300x300",
            name: "上传失败",
            status: "fail",
          },
        })
      }, 500)
    }
  }

  onUpload = () => {
    const data = {}
    // 附加的heads
    const headers = {}
    // 开始上传
    this.fileUploaderRef.startUpload(data, headers)
  }

  handleCreativeDelete = (event) => {
    // this.props.onChange('advertisingInfo', { ...this.props.value, creative_attachment_ids: {values: []} });
    // this.props.onChange('advertisingInfo', { ...this.props.value, creativeAttachments: [] });
    this.setState({
      uploadStatus: {}, // 初始状态
    })
  }

  handleOpen = () => {
    this.setState({
      open: !this.state.open,
    })
  }

  validEachFieldIsEmpty = (type) => {
    const { ad_platform_types } = this.props.value || [];
    let result = true
    let map
    if (type === "GDT") {
      map = { ...requiredFieldMapByGDT, ...requiredFieldMap }
    } else if ("WeChat") {
      map = { ...requiredFieldMapByWeChat, ...requiredFieldMap }
    }
    let keys = Object.keys(map)
    // 有一级推广目标为附近推时，跳过二级目标校验
    if (ad_platform_types) {
      // keys = _.filter(keys, (v) => v !== "promoted_object")
      this.setState({ promotedObjectErr: "" })
    }
    keys.forEach((key) => {
      const stateVal = this.props.value[key]
      const mapVal = map[key]
      const { tip, errField } = mapVal

      if (!stateVal) {
        result = false
        this.setState({
          [errField]: tip,
        })
      } else {
        this.setState({
          [errField]: "",
        })
      }
    })

    return result
  }

  inputValidate = (value, field) => {
    const { tip, errField } = requiredFieldMap[field]
    if (value) {
      this.setState({
        [errField]: "",
      })
    } else {
      this.setState({
        [errField]: tip,
      })
    }
  }

  resetErrStatus = () => {
    this.setState({
      operationModeErr: "",
      adPlatformTypeErr: "",
      promotedObjectErr: "",
      promotionBusinessErr: "",
      dayBudgetPromisedErr: "",
      onlineTimePromisedErr: "",
      effectPromisedErr: "",
      memoPromisedErr: "",
      competitionErr: "",
      landingPageUrlErr: "",
      creativeAttachmentIdsErr: "",
    })
  }

  render() {
    const { operationModeErr, adPlatformTypeErr, promotedObjectErr, promotionBusinessErr, dayBudgetPromisedErr, onlineTimePromisedErr, effectPromisedErr, memoPromisedErr, competitionErr, landingPageUrlErr, creativeAttachmentIdsErr, uploadStatus, open } = this.state
    const {
      value: {
        operation_mode,
        ad_platform_types,
        promoted_object,
        promotion_business,
        day_budget_promised,
        online_time_promised,
        effect_promised,
        memo_promised,
        competition,
        landing_page_url,
        // creative_attachment_ids,
        creativeAttachments,
      },
    } = this.props;

    return (
      <div className="lump">
        <h2 style={{ fontSize: "18px" }} className="lump-hd">
          投放信息
          <a style={{ fontSize: "14px" }} href="javascript:;" onClick={this.handleOpen}>
            {" "}
            - {open ? "合上投放信息" : "展开填写投放信息"}
          </a>
        </h2>
        <Collapse open={open}>
          <div className="lump-bd">
            <ul className="infos">
              <li className="infolist required">
                <span className="info-tt">运营方式</span>
                <div className="info-des">
                  <FormGroup error={operationModeErr}>
                    <OrderCreateAccountSelect value={operation_mode} onChange={this.changeOperationMode} />
                  </FormGroup>
                </div>
              </li>
              <li className="infolist">
                <span className="info-tt">推广目标</span>
                <div className="info-des">
                  <FormGroup error={adPlatformTypeErr || promotedObjectErr}>
                    <PromotedObjectSelect adPlatformTypes={ad_platform_types} promotedObject={promoted_object} onChange={this.changePromotedObject} />
                  </FormGroup>
                </div>
              </li>
              <li className="infolist">
                <span className="info-tt">推广业务/产品/内容</span>
                <div className="info-des">
                  <FormGroup error={promotionBusinessErr}>
                    <Input
                      placeholder="广告主首次想推广的业务/产品/营销内容等
                                          举例：火锅店-新店开业；售卖健身课程-9.9元周体验卡"
                      value={promotion_business}
                      onChange={this.changePromotionBusiness}
                    />
                  </FormGroup>
                </div>
              </li>
              <li className="infolist">
                <span className="info-tt">客户上线承诺备注-每日预算</span>
                <div className="info-des">
                  <FormGroup error={dayBudgetPromisedErr}>
                    <Input placeholder="举例：每日预算500元" value={day_budget_promised} onChange={this.changeDayBudgetPromised} />
                  </FormGroup>
                </div>
              </li>
              <li className="infolist">
                <span className="info-tt">客户上线承诺备注-上线时间</span>
                <div className="info-des">
                  <FormGroup style={{ marginBottom: "30px" }} error={onlineTimePromisedErr}>
                    <Input placeholder="举例：12月13日" value={online_time_promised} onChange={this.changeOnlineTimePromised} />
                  </FormGroup>
                </div>
              </li>
              <li className="infolist">
                <span className="info-tt">客户上线承诺备注-效果/转化成本</span>
                <div className="info-des">
                  <FormGroup error={effectPromisedErr}>
                    <Input placeholder="举例：日曝光量5w次；线索成本100元/个等" value={effect_promised} onChange={this.changeEffectPromised} />
                  </FormGroup>
                </div>
              </li>
              <li className="infolist">
                <span className="info-tt">客户上线承诺备注-其他</span>
                <div className="info-des">
                  <FormGroup error={memoPromisedErr}>
                    <Input placeholder="其他提前跟客户承诺的内容，如视频拍摄、活动策划等" value={memo_promised} onChange={this.changeMemoPromised} />
                  </FormGroup>
                </div>
              </li>
              <li className="infolist infolist-tt-ver">
                <span className="info-tt">竞品媒体平台及效果</span>
                <div className="info-des">
                  <FormGroup error={competitionErr}>
                    <Input placeholder="举例：投放抖音，线索成本100元" value={competition} onChange={this.changeCompetition} />
                  </FormGroup>
                </div>
              </li>
              <li className="infolist infolist-tt-ver">
                <span className="info-tt">投放链接</span>
                <div className="info-des">
                  <FormGroup error={landingPageUrlErr}>
                    <Input placeholder="请输入投放链接" value={landing_page_url} onChange={this.changeLandingPageUrl} />
                  </FormGroup>
                </div>
              </li>
              <li className="infolist">
                <span className="info-tt">素材附件</span>
                <div className="info-des">
                  <FormGroup error={creativeAttachmentIdsErr}>
                    <FileUploader
                      headers={{
                        withCredentials: true,
                        "X-API-KEY": "abc",
                      }}
                      multiple
                      uploadText="选择文件"
                      reuploadText="重新选择"
                      autoUpload={false}
                      name="image"
                      url={ATTACHMENT_UPLOAD_URL}
                      value={uploadStatus}
                      onUpload={this.fileChange}
                      onDelete={this.handleCreativeDelete}
                      onComplete={this.handleCreativeAttachmentIds}
                      ref={(el) => (this.fileUploaderRef = el)}
                    />
                    <br />
                    <br />
                    <span
                      style={{ color: "#2096f5", cursor: "pointer" }}
                      onClick={() =>
                        // 开始上传
                        this.fileUploaderRef.startUpload()
                      }
                    >
                      开始上传
                    </span>
                    {creativeAttachments.length ? (
                      <div>
                        <span>附件：</span>
                        {creativeAttachments.map((item, key) => (
                          <div style={{ display: "flex" }}>
                            <div>
                              <a key={key} href={item.url}>
                                {key + 1}：{item.attachmentName}
                              </a>
                            </div>
                            <div onClick={() => this.deleteAttachment(item, key)}>
                              <Icon type="delete" />
                            </div>
                            <br />
                          </div>
                        ))}
                      </div>
                    ) : null}
                  </FormGroup>
                  {/* <span>{this.props.creative_attachment_ids&&this.props.creative_attachment_ids.values?this.props.creative_attachment_ids.values:[]}</span> */}
                </div>
              </li>
            </ul>
          </div>
        </Collapse>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    response: state,
  }
}

export default connect(mapStateToProps)(advertisingInfo)
